export default {
    development: {
        compositionApi: 'https://api.test-sdbleerplatform.nl/api/1.0/composition',
        ltiConsumerApi: 'https://lticonsumer.test-sdbleerplatform.nl',
        catalogApi: 'https://app-sdblearning-test-catalog.azurewebsites.net',
        sdbIdentityUrl: 'test-sdbidentity.nl',
    },
    production: {
        compositionApi: 'https://api.sdbleerplatform.nl/api/1.0/composition',
        ltiConsumerApi: 'https://lticonsumer.sdbleerplatform.nl',
        catalogApi: 'https://catalogapi.sdbleerplatform.nl',
        sdbIdentityUrl: 'sdbidentity.nl',
    },
}
